import type {SocialAccount} from '@Components/social-media/account.vo';
import type {InstagramReelMusic} from '@Components/social-media/publish-params.types';
import type {InstagramAudioTrack} from '@Components/social-media-wizard/social-media-wizard.types';

export const REEL_MUSIC_POPUP_OFFSET_PX = 8;
export const REEL_MUSIC_POPUP_MAX_HEIGHT_PX = 480;
export const REEL_MUSIC_PICKER_SPACING_CLASSES = 'spacing-p-0';
export const REEL_MUSIC_MODAL_PANEL_ID = 'instagram-reel-music-search-modal';
export const REEL_MUSIC_MODAL_MAX_HEIGHT = '80vh';

export interface ReelMusicFieldProps {
  account: SocialAccount;
  isVideoDesign: boolean;
}

export interface ReelMusicFieldState {
  isAvailable: boolean;
  reelMusic: InstagramReelMusic | null;
  selectTrack: (track: InstagramAudioTrack) => void;
  clearReelMusic: VoidFunction;
}
